module.exports = __webpack_public_path__ + "assets/img/pingpong.6d073793.svg";